import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const LOGO = "/logos/sterilemate-white.png?v=4";

const IMG = {
  cover: "https://images.unsplash.com/photo-1764885518098-781b23d50e7f?w=1200&q=80",
  hospital: "https://images.unsplash.com/photo-1769698678497-c41f0ab47c3e?w=900&q=80",
  construction: "https://images.unsplash.com/photo-1768321916340-b05845f26f9e?w=900&q=80",
  interior: "https://images.unsplash.com/photo-1775564578339-098d727ff924?w=900&q=80",
  hallway: "https://images.unsplash.com/photo-1762647460856-6b610c50b575?w=900&q=80",
  room: "https://images.unsplash.com/photo-1768321914670-80db17b4669b?w=900&q=80",
  workers: "https://images.unsplash.com/photo-1772299121503-cd62a57e3a26?w=900&q=80",
};

const c = { navy: '#003366', blue: '#0056A8', sky: '#60A5FA', teal: '#0D9488', emerald: '#10B981', amber: '#F59E0B', slate: '#334155', light: '#F8FAFC', muted: '#64748B', border: '#E2E8F0', white: '#FFFFFF' };

const s = StyleSheet.create({
  page: { padding: 40, backgroundColor: c.white, fontFamily: 'Helvetica' },
  coverPage: { padding: 0, backgroundColor: c.navy },
  hdr: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18, paddingBottom: 6, borderBottomWidth: 2, borderBottomColor: c.navy },
  hdrTxt: { fontSize: 8, color: c.muted },
  title: { fontSize: 22, fontWeight: 'bold', color: c.navy, marginBottom: 10 },
  sub: { fontSize: 12, color: c.muted, marginBottom: 10 },
  p: { fontSize: 10, lineHeight: 1.6, color: c.slate, marginBottom: 8, textAlign: 'justify' },
  bold: { fontWeight: 'bold' },
  card: { padding: 12, backgroundColor: c.light, borderRadius: 6, borderWidth: 1, borderColor: c.border, marginBottom: 8 },
  cardT: { fontSize: 11, fontWeight: 'bold', color: c.navy, marginBottom: 4 },
  cardP: { fontSize: 9, color: c.muted, lineHeight: 1.4 },
  row: { flexDirection: 'row' },
  metric: { padding: 10, backgroundColor: c.light, borderRadius: 6, alignItems: 'center', borderWidth: 1, borderColor: c.border },
  metricV: { fontSize: 16, fontWeight: 'bold', color: c.navy, marginBottom: 2 },
  metricL: { fontSize: 7, color: c.muted, textAlign: 'center' },
  tHd: { flexDirection: 'row', backgroundColor: c.navy, padding: 8 },
  tHdC: { flex: 1, fontSize: 9, fontWeight: 'bold', color: c.white },
  tR: { flexDirection: 'row', padding: 8, borderBottomWidth: 1, borderBottomColor: c.border },
  tRA: { backgroundColor: c.light },
  tC: { flex: 1, fontSize: 9, color: c.slate },
  bul: { flexDirection: 'row', marginBottom: 5 },
  bulD: { width: 12, fontSize: 9, color: c.emerald },
  bulT: { flex: 1, fontSize: 9, color: c.slate, lineHeight: 1.4 },
  ft: { position: 'absolute', bottom: 20, left: 40, right: 40, flexDirection: 'row', justifyContent: 'space-between', borderTopWidth: 1, borderTopColor: c.border, paddingTop: 8 },
  ftT: { fontSize: 7, color: c.muted },
  greenBox: { backgroundColor: '#ECFDF5', borderLeftWidth: 3, borderLeftColor: c.emerald, padding: 12, marginVertical: 8 },
  blueBox: { backgroundColor: '#EFF6FF', borderLeftWidth: 3, borderLeftColor: c.blue, padding: 12, marginVertical: 8 },
  amberBox: { backgroundColor: '#FEF3C7', borderLeftWidth: 3, borderLeftColor: c.amber, padding: 12, marginVertical: 8 },
});

const Hdr = ({ t }) => (
  <View style={s.hdr}>
    <Text style={s.hdrTxt}>Sterile Mate LLC | Healthcare General Contracting</Text>
    <Text style={s.hdrTxt}>{t}</Text>
  </View>
);
const Ft = () => (
  <View style={s.ft}>
    <Text style={s.ftT}>Sterile Mate LLC — HUB Certified | Licensed | Healthcare Compliant</Text>
    <Text style={s.ftT}>george.broughton@sterilemate.com</Text>
  </View>
);
const Bul = ({ children }) => (
  <View style={s.bul}>
    <Text style={s.bulD}>&#x2022;</Text>
    <Text style={s.bulT}>{children}</Text>
  </View>
);

const GeneralContractorBrochurePDF = () => (
  <Document>
    {/* ==================== COVER ==================== */}
    <Page size="A4" style={s.coverPage}>
      <View style={{ flex: 1 }}>
        <Image src={IMG.cover} style={{ width: '100%', height: 340, objectFit: 'cover' }} />
        <View style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 340, backgroundColor: 'rgba(0,51,102,0.6)' }} />
        <View style={{ position: 'absolute', top: 25, left: 30, flexDirection: 'row', alignItems: 'center', gap: 12 }}>
          <Image src={LOGO} style={{ width: 45, height: 45, borderRadius: 8 }} />
          <View>
            <Text style={{ fontSize: 18, fontWeight: 'bold', color: c.white }}>STERILE MATE LLC</Text>
            <Text style={{ fontSize: 9, color: c.sky }}>Keeping You Safe</Text>
          </View>
        </View>
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 40 }}>
          <Text style={{ fontSize: 14, fontWeight: 'bold', color: c.sky, textAlign: 'center', letterSpacing: 3, marginBottom: 12 }}>HEALTHCARE GENERAL CONTRACTING</Text>
          <Text style={{ fontSize: 30, fontWeight: 'bold', color: c.white, textAlign: 'center', marginBottom: 8 }}>
            Electrical. Plumbing.{'\n'}Construction.
          </Text>
          <Text style={{ fontSize: 13, color: '#CBD5E1', textAlign: 'center', marginBottom: 20 }}>
            Licensed, Experienced & Healthcare-Compliant Contracting{'\n'}for Hospitals, Health Systems & Medical Facilities
          </Text>
          <View style={{ backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: 8, padding: 16, width: '90%' }}>
            <Text style={{ fontSize: 11, color: c.white, textAlign: 'center', marginBottom: 4 }}>
              No Job Too Big. No Job Too Small.
            </Text>
            <Text style={{ fontSize: 10, color: c.sky, textAlign: 'center' }}>
              Capital Projects | Room Buildouts | Repairs | Remodels | New Construction
            </Text>
          </View>
        </View>
        <View style={{ position: 'absolute', bottom: 25, left: 0, right: 0, flexDirection: 'row', justifyContent: 'center', gap: 30 }}>
          <Text style={{ fontSize: 8, color: '#94A3B8' }}>HUB Certified</Text>
          <Text style={{ fontSize: 8, color: '#94A3B8' }}>Licensed Technicians</Text>
          <Text style={{ fontSize: 8, color: '#94A3B8' }}>Healthcare Compliant</Text>
          <Text style={{ fontSize: 8, color: '#94A3B8' }}>Houston, TX</Text>
        </View>
      </View>
    </Page>

    {/* ==================== COMPANY OVERVIEW ==================== */}
    <Page size="A4" style={s.page}>
      <Hdr t="Company Overview" />
      <Text style={s.title}>Who We Are</Text>
      <Text style={s.sub}>A Healthcare-Focused General Contractor You Can Trust</Text>
      <Text style={s.p}>
        <Text style={s.bold}>Sterile Mate LLC</Text> is a Houston-based healthcare solutions provider with over six years of hands-on experience serving hospitals, health systems, and medical facilities across Texas and the VA system nationwide. Our licensed, experienced technicians carry years of expertise in healthcare, industrial, commercial, and residential contracting.
      </Text>
      <Text style={s.p}>
        What sets us apart is our deep understanding of the healthcare environment. We don't just do construction — we <Text style={s.bold}>build for compliance</Text>. Every technician is fully vetted for healthcare standards, every project meets all compliance measures required in medical settings, and every job is executed with the precision that hospitals demand.
      </Text>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginVertical: 12 }}>
        {[
          { v: '6+ Years', l: 'Healthcare Experience' },
          { v: 'Licensed', l: 'Master Technicians' },
          { v: '100%', l: 'Compliance Rate' },
          { v: 'HUB', l: 'Certified Contractor' },
        ].map((m, i) => (
          <View key={i} style={{ ...s.metric, width: '23%' }}>
            <Text style={s.metricV}>{m.v}</Text>
            <Text style={s.metricL}>{m.l}</Text>
          </View>
        ))}
      </View>
      <Text style={{ ...s.sub, fontWeight: 'bold', marginTop: 8 }}>Trusted By</Text>
      <View style={s.greenBox}>
        <Text style={{ fontSize: 10, color: c.slate, lineHeight: 1.6 }}>
          <Text style={{ fontWeight: 'bold', color: c.navy }}>Harris County Healthcare System</Text> — Capital projects, plumbing systems, electrical upgrades, and room buildouts across multiple facilities.{'\n'}
          <Text style={{ fontWeight: 'bold', color: c.navy }}>State of Texas</Text> — Licensed government contractor for healthcare facility construction and maintenance.{'\n'}
          <Text style={{ fontWeight: 'bold', color: c.navy }}>VA Medical Centers</Text> — Nationwide service for water purification systems, plumbing, and facility maintenance.
        </Text>
      </View>
      <Text style={{ ...s.sub, fontWeight: 'bold', marginTop: 8 }}>Sectors Served</Text>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
        {['Hospitals & Health Systems', 'Surgical Centers', 'Dialysis Centers', 'Dental Clinics', 'VA Medical Centers', 'Commercial & Industrial', 'Residential'].map((sector, i) => (
          <View key={i} style={{ paddingHorizontal: 10, paddingVertical: 5, backgroundColor: i < 5 ? '#EFF6FF' : c.light, borderRadius: 4, borderWidth: 1, borderColor: i < 5 ? '#BFDBFE' : c.border }}>
            <Text style={{ fontSize: 8, color: i < 5 ? c.blue : c.muted }}>{sector}</Text>
          </View>
        ))}
      </View>
      <Ft />
    </Page>

    {/* ==================== CORE SERVICES ==================== */}
    <Page size="A4" style={s.page}>
      <Hdr t="Core Services" />
      <Text style={s.title}>Our Services</Text>
      <Text style={s.sub}>End-to-End General Contracting for Healthcare Facilities</Text>

      {/* Electrical */}
      <View style={{ ...s.card, borderLeftWidth: 4, borderLeftColor: c.amber }}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <Text style={{ ...s.cardT, fontSize: 14, color: c.amber }}>Electrical Services</Text>
          <Text style={{ fontSize: 8, color: c.amber, fontWeight: 'bold', backgroundColor: '#FEF3C7', paddingHorizontal: 8, paddingVertical: 3, borderRadius: 4 }}>LICENSED</Text>
        </View>
        <Text style={s.cardP}>Our licensed electricians specialize in healthcare-grade electrical systems — from panel upgrades and circuit installations to emergency generator connections and code-compliant wiring for medical equipment.</Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
          {['Electrical Panel Upgrades', 'Medical Equipment Wiring', 'Emergency Power Systems', 'Lighting Systems', 'Code Compliance Retrofits', 'Circuit Installation & Repair', 'Generator Connections', 'Fire Alarm Systems'].map((item, i) => (
            <View key={i} style={{ paddingHorizontal: 8, paddingVertical: 3, backgroundColor: '#FEF3C7', borderRadius: 3 }}>
              <Text style={{ fontSize: 7, color: '#92400E' }}>{item}</Text>
            </View>
          ))}
        </View>
      </View>

      {/* Plumbing */}
      <View style={{ ...s.card, borderLeftWidth: 4, borderLeftColor: c.blue }}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <Text style={{ ...s.cardT, fontSize: 14, color: c.blue }}>Plumbing Services</Text>
          <Text style={{ fontSize: 8, color: c.blue, fontWeight: 'bold', backgroundColor: '#EFF6FF', paddingHorizontal: 8, paddingVertical: 3, borderRadius: 4 }}>MASTER PLUMBER</Text>
        </View>
        <Text style={s.cardP}>Healthcare plumbing requires precision and compliance. Our master plumbers build and maintain the critical systems that hospitals depend on — from sterile processing water lines to gas piping and medical gas systems.</Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
          {['Healthcare Water Systems', 'Medical Gas Piping', 'Leak Detection & Repair', 'Gas Line Installation', 'Backflow Prevention', 'Drain & Sewer Systems', 'Water Heater Systems', 'Code-Compliant Retrofits'].map((item, i) => (
            <View key={i} style={{ paddingHorizontal: 8, paddingVertical: 3, backgroundColor: '#EFF6FF', borderRadius: 3 }}>
              <Text style={{ fontSize: 7, color: '#1E40AF' }}>{item}</Text>
            </View>
          ))}
        </View>
      </View>

      {/* Construction */}
      <View style={{ ...s.card, borderLeftWidth: 4, borderLeftColor: c.emerald }}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <Text style={{ ...s.cardT, fontSize: 14, color: c.emerald }}>Construction & Buildout</Text>
          <Text style={{ fontSize: 8, color: c.emerald, fontWeight: 'bold', backgroundColor: '#ECFDF5', paddingHorizontal: 8, paddingVertical: 3, borderRadius: 4 }}>GENERAL CONTRACTOR</Text>
        </View>
        <Text style={s.cardP}>From full room buildouts and patient area remodels to new construction and facility expansions — we manage it all. Our team handles every phase: framing, drywall, flooring, paint, medical-grade finishes, and final inspection.</Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
          {['Room Buildouts', 'Patient Area Remodels', 'New Construction', 'Drywall & Framing', 'Medical-Grade Flooring', 'Painting & Finishes', 'Demolition', 'ADA Compliance'].map((item, i) => (
            <View key={i} style={{ paddingHorizontal: 8, paddingVertical: 3, backgroundColor: '#ECFDF5', borderRadius: 3 }}>
              <Text style={{ fontSize: 7, color: '#065F46' }}>{item}</Text>
            </View>
          ))}
        </View>
      </View>

      {/* Repairs */}
      <View style={{ ...s.card, borderLeftWidth: 4, borderLeftColor: '#8B5CF6' }}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <Text style={{ ...s.cardT, fontSize: 14, color: '#8B5CF6' }}>Repairs & Maintenance</Text>
          <Text style={{ fontSize: 8, color: '#8B5CF6', fontWeight: 'bold', backgroundColor: '#F5F3FF', paddingHorizontal: 8, paddingVertical: 3, borderRadius: 4 }}>24/7 RESPONSE</Text>
        </View>
        <Text style={s.cardP}>Hospitals never close — and neither do we. Our repair crews handle emergency leaks, gas repairs, electrical outages, and urgent facility issues with the speed and compliance healthcare demands.</Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
          {['Emergency Leak Repair', 'Gas Line Repairs', 'Electrical Troubleshooting', 'HVAC Support', 'Fixture Replacement', 'Preventive Maintenance', 'After-Hours Service', 'Priority Response'].map((item, i) => (
            <View key={i} style={{ paddingHorizontal: 8, paddingVertical: 3, backgroundColor: '#F5F3FF', borderRadius: 3 }}>
              <Text style={{ fontSize: 7, color: '#5B21B6' }}>{item}</Text>
            </View>
          ))}
        </View>
      </View>
      <Ft />
    </Page>

    {/* ==================== WHY HEALTHCARE COMPLIANCE MATTERS ==================== */}
    <Page size="A4" style={s.page}>
      <Hdr t="Healthcare Compliance" />
      <Text style={s.title}>Healthcare Compliance Is Not Optional</Text>
      <Text style={s.sub}>Why Hospitals Choose Sterile Mate Over General Contractors</Text>
      <Text style={s.p}>
        Working in a hospital is fundamentally different from working in a commercial building. Patient safety, infection control, air quality, noise restrictions, and regulatory compliance create a set of requirements that most general contractors simply don't understand. At Sterile Mate, <Text style={s.bold}>compliance is in our DNA</Text> — it's not an afterthought.
      </Text>

      <View style={{ borderWidth: 1, borderColor: c.border, borderRadius: 6, marginBottom: 12 }}>
        <View style={s.tHd}>
          <Text style={{ ...s.tHdC, flex: 2 }}>Compliance Area</Text>
          <Text style={s.tHdC}>Standard Contractor</Text>
          <Text style={s.tHdC}>Sterile Mate</Text>
        </View>
        {[
          ['ICRA (Infection Control Risk Assessment)', 'Unfamiliar', 'Fully Compliant'],
          ['ILSM (Interim Life Safety Measures)', 'Rarely Addressed', 'Always Implemented'],
          ['Background Checks & Badging', 'Basic Check', 'Full Healthcare Vetting'],
          ['OSHA Healthcare Standards', 'General OSHA Only', 'Healthcare-Specific'],
          ['Joint Commission Awareness', 'Minimal', 'Embedded in Process'],
          ['Noise & Disruption Management', 'Not Considered', 'Scheduled & Managed'],
          ['Infection Control Barriers', 'Plastic Sheeting', 'HEPA + Neg. Pressure'],
          ['Documentation & Closeout', 'Basic Paperwork', 'Audit-Ready Package'],
        ].map(([area, standard, sm], i) => (
          <View key={i} style={{ ...s.tR, ...(i % 2 ? s.tRA : {}) }}>
            <Text style={{ ...s.tC, flex: 2, fontWeight: 'bold' }}>{area}</Text>
            <Text style={{ ...s.tC, color: '#DC2626' }}>{standard}</Text>
            <Text style={{ ...s.tC, color: c.emerald, fontWeight: 'bold' }}>{sm}</Text>
          </View>
        ))}
      </View>

      <View style={s.greenBox}>
        <Text style={{ fontSize: 10, color: c.slate, lineHeight: 1.5 }}>
          <Text style={{ fontWeight: 'bold' }}>Every Sterile Mate technician is:</Text>{'\n'}
          - Background checked and cleared for healthcare facility access{'\n'}
          - Trained in infection control protocols (ICRA Class I-IV){'\n'}
          - OSHA Healthcare certified and badge-compliant{'\n'}
          - Experienced in working around live patient areas without disruption
        </Text>
      </View>
      <Ft />
    </Page>

    {/* ==================== PROJECT TYPES ==================== */}
    <Page size="A4" style={s.page}>
      <Hdr t="Project Types" />
      <Text style={s.title}>Projects We Deliver</Text>
      <Text style={s.sub}>From Emergency Repairs to Full Capital Projects — We Handle It All</Text>

      <View style={{ flexDirection: 'row', gap: 8, marginBottom: 10 }}>
        <View style={{ ...s.card, flex: 1, borderTopWidth: 3, borderTopColor: c.navy }}>
          <Text style={{ ...s.cardT, fontSize: 12 }}>Capital Projects</Text>
          <Text style={s.cardP}>Full-scale healthcare construction managed from design to certificate of occupancy. Electrical, plumbing, and structural all under one contractor.</Text>
          <Bul>New facility buildouts</Bul>
          <Bul>Floor-to-ceiling renovations</Bul>
          <Bul>Multi-phase construction</Bul>
          <Bul>Infrastructure upgrades</Bul>
        </View>
        <View style={{ ...s.card, flex: 1, borderTopWidth: 3, borderTopColor: c.blue }}>
          <Text style={{ ...s.cardT, fontSize: 12 }}>Room Buildouts</Text>
          <Text style={s.cardP}>Converting raw or existing space into functional clinical environments. Patient rooms, labs, sterile processing, operating suites.</Text>
          <Bul>Patient rooms & suites</Bul>
          <Bul>Operating rooms</Bul>
          <Bul>Sterile processing departments</Bul>
          <Bul>Lab & diagnostic areas</Bul>
        </View>
      </View>

      <View style={{ flexDirection: 'row', gap: 8, marginBottom: 10 }}>
        <View style={{ ...s.card, flex: 1, borderTopWidth: 3, borderTopColor: c.emerald }}>
          <Text style={{ ...s.cardT, fontSize: 12 }}>Remodels & Upgrades</Text>
          <Text style={s.cardP}>Updating existing healthcare spaces to meet modern standards, improve patient experience, and ensure code compliance.</Text>
          <Bul>Bathroom & restroom ADA upgrades</Bul>
          <Bul>Nurse station renovations</Bul>
          <Bul>Lobby & waiting area redesigns</Bul>
          <Bul>Electrical system modernization</Bul>
        </View>
        <View style={{ ...s.card, flex: 1, borderTopWidth: 3, borderTopColor: c.amber }}>
          <Text style={{ ...s.cardT, fontSize: 12 }}>Repairs & Emergency</Text>
          <Text style={s.cardP}>Rapid response for facility issues that can't wait. Our team is on call to keep your hospital running safely 24/7.</Text>
          <Bul>Water leaks & pipe bursts</Bul>
          <Bul>Gas line emergencies</Bul>
          <Bul>Electrical outages & shorts</Bul>
          <Bul>Structural damage response</Bul>
        </View>
      </View>

      <Text style={{ ...s.sub, fontWeight: 'bold', marginTop: 8 }}>Reference Project: Harris County Healthcare System</Text>
      <View style={s.blueBox}>
        <Text style={{ fontSize: 10, color: c.slate, lineHeight: 1.6 }}>
          <Text style={{ fontWeight: 'bold', color: c.navy }}>Scope:</Text> Healthcare plumbing systems, electrical upgrades for capital projects, room buildouts, gas repairs, water system installations, and ongoing facility maintenance across multiple Harris Health locations.{'\n\n'}
          <Text style={{ fontWeight: 'bold', color: c.navy }}>Disciplines:</Text> Electrical | Plumbing | Construction | Water Purification{'\n'}
          <Text style={{ fontWeight: 'bold', color: c.navy }}>Result:</Text> All projects completed on schedule, within budget, and fully compliant with Joint Commission and state regulatory standards.
        </Text>
      </View>
      <Ft />
    </Page>

    {/* ==================== OUR APPROACH ==================== */}
    <Page size="A4" style={s.page}>
      <Hdr t="Our Approach" />
      <Text style={s.title}>How We Work</Text>
      <Text style={s.sub}>A Process Built for Healthcare — From Estimate to Closeout</Text>

      {[
        { n: '01', t: 'Site Assessment & Compliance Review', d: 'We evaluate the work area, identify ICRA classifications, document existing conditions, and develop a compliance-first project plan — before a single tool is picked up.' },
        { n: '02', t: 'Detailed Scope & Estimate', d: 'Transparent, detailed proposals with clear line items. No hidden charges. We spec materials, labor, timeline, and compliance measures upfront.' },
        { n: '03', t: 'Healthcare-Compliant Execution', d: 'Our vetted, badged technicians execute with infection control barriers, noise management, and patient safety protocols in place at all times. Work is scheduled around hospital operations.' },
        { n: '04', t: 'Quality Inspection & Testing', d: 'Every electrical circuit is tested, every plumbing joint is pressure-checked, every surface is inspected. We don\'t hand off until it\'s right.' },
        { n: '05', t: 'Documentation & Closeout', d: 'Complete audit-ready documentation: as-built drawings, inspection certificates, compliance checklists, warranty information, and photographic records of all work performed.' },
      ].map((step, i) => (
        <View key={i} style={{ flexDirection: 'row', gap: 12, marginBottom: 10 }}>
          <View style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: c.navy, justifyContent: 'center', alignItems: 'center' }}>
            <Text style={{ fontSize: 14, fontWeight: 'bold', color: c.white }}>{step.n}</Text>
          </View>
          <View style={{ flex: 1 }}>
            <Text style={{ fontSize: 11, fontWeight: 'bold', color: c.navy, marginBottom: 3 }}>{step.t}</Text>
            <Text style={{ fontSize: 9, color: c.muted, lineHeight: 1.5 }}>{step.d}</Text>
          </View>
        </View>
      ))}

      <Text style={{ ...s.sub, fontWeight: 'bold', marginTop: 15 }}>Why Choose Sterile Mate?</Text>
      <View style={{ flexDirection: 'row', gap: 8 }}>
        {[
          { t: 'One Contractor', d: 'Electrical, plumbing, construction — all under one roof. No subcontractor coordination headaches.' },
          { t: 'Healthcare DNA', d: '6+ years exclusively in healthcare. We know your compliance needs before you tell us.' },
          { t: 'Audit-Ready', d: 'Every project includes full documentation packages ready for Joint Commission or state inspection.' },
          { t: 'No Job Too Small', d: 'From a single leaking faucet to a $500K capital project — we show up with the same professionalism.' },
        ].map((item, i) => (
          <View key={i} style={{ ...s.card, flex: 1, borderTopWidth: 2, borderTopColor: [c.navy, c.emerald, c.blue, c.amber][i] }}>
            <Text style={{ ...s.cardT, fontSize: 9 }}>{item.t}</Text>
            <Text style={{ fontSize: 8, color: c.muted, lineHeight: 1.3 }}>{item.d}</Text>
          </View>
        ))}
      </View>
      <Ft />
    </Page>

    {/* ==================== CREDENTIALS & CONTACT ==================== */}
    <Page size="A4" style={s.page}>
      <Hdr t="Credentials & Contact" />
      <Text style={s.title}>Credentials & Certifications</Text>

      <View style={{ flexDirection: 'row', gap: 10, marginBottom: 15 }}>
        {[
          { t: 'HUB Certified', d: 'State of Texas Historically Underutilized Business — eligible for government contracts and procurement set-asides.' },
          { t: 'SAM Registered', d: 'System for Award Management — cleared for federal government contracting including VA and DoD projects.' },
          { t: 'Licensed Contractor', d: 'All technicians hold current state licenses for electrical, plumbing, and general contracting work.' },
          { t: 'Healthcare Compliant', d: 'ICRA trained, OSHA Healthcare certified, Joint Commission aware. Full background checks and facility badging.' },
        ].map((cred, i) => (
          <View key={i} style={{ ...s.card, flex: 1, alignItems: 'center', textAlign: 'center' }}>
            <Text style={{ ...s.cardT, fontSize: 11, textAlign: 'center' }}>{cred.t}</Text>
            <Text style={{ ...s.cardP, textAlign: 'center' }}>{cred.d}</Text>
          </View>
        ))}
      </View>

      <Text style={{ ...s.sub, fontWeight: 'bold' }}>Industries We Serve</Text>
      <View style={{ borderWidth: 1, borderColor: c.border, borderRadius: 6, marginBottom: 15 }}>
        <View style={s.tHd}>
          <Text style={{ ...s.tHdC, flex: 2 }}>Industry</Text>
          <Text style={s.tHdC}>Services</Text>
        </View>
        {[
          ['Healthcare — Hospitals & Health Systems', 'Full GC: Electrical, Plumbing, Construction, Repairs'],
          ['Healthcare — Surgical & Dialysis Centers', 'Room Buildouts, Water Systems, Electrical'],
          ['Industrial & Commercial', 'Tenant Improvements, Electrical, Plumbing'],
          ['Government (State & Federal)', 'Capital Projects, Facility Maintenance'],
          ['Residential', 'Remodels, Electrical, Plumbing, New Construction'],
        ].map(([ind, svc], i) => (
          <View key={i} style={{ ...s.tR, ...(i % 2 ? s.tRA : {}) }}>
            <Text style={{ ...s.tC, flex: 2, fontWeight: 'bold' }}>{ind}</Text>
            <Text style={s.tC}>{svc}</Text>
          </View>
        ))}
      </View>

      <View style={{ padding: 25, backgroundColor: c.light, borderRadius: 8, marginBottom: 15 }}>
        <Text style={{ fontSize: 16, fontWeight: 'bold', color: c.navy, marginBottom: 3, textAlign: 'center' }}>Contact Us</Text>
        <Text style={{ fontSize: 10, color: c.muted, marginBottom: 15, textAlign: 'center' }}>Ready to discuss your next project? We respond within 24 hours.</Text>
        <View style={{ flexDirection: 'row', gap: 20 }}>
          <View style={{ flex: 1 }}>
            <Text style={{ fontSize: 9, color: c.muted, marginBottom: 2 }}>Contact</Text>
            <Text style={{ fontSize: 11, fontWeight: 'bold', color: c.navy }}>George Broughton III</Text>
            <Text style={{ fontSize: 10, color: c.slate }}>Founder & CEO</Text>
          </View>
          <View style={{ flex: 1 }}>
            <Text style={{ fontSize: 9, color: c.muted, marginBottom: 2 }}>Email</Text>
            <Text style={{ fontSize: 11, color: c.blue }}>george.broughton@sterilemate.com</Text>
            <Text style={{ fontSize: 9, color: c.muted, marginTop: 6 }}>Phone</Text>
            <Text style={{ fontSize: 10, color: c.slate }}>Office: 281.456.3458</Text>
            <Text style={{ fontSize: 10, color: c.slate }}>Mobile: 323.243.9139</Text>
          </View>
          <View style={{ flex: 1 }}>
            <Text style={{ fontSize: 9, color: c.muted, marginBottom: 2 }}>Web</Text>
            <Text style={{ fontSize: 10, color: c.blue }}>www.sterilemate.com</Text>
            <Text style={{ fontSize: 10, color: c.blue }}>AskIsaac.io</Text>
            <Text style={{ fontSize: 9, color: c.muted, marginTop: 6 }}>Office</Text>
            <Text style={{ fontSize: 9, color: c.slate }}>396 W Greens Road{'\n'}Suite 1139{'\n'}Houston, TX 77067</Text>
          </View>
        </View>
      </View>

      <View style={{ padding: 15, backgroundColor: c.navy, borderRadius: 8, alignItems: 'center' }}>
        <Text style={{ fontSize: 13, color: c.white, fontWeight: 'bold' }}>Sterile Mate LLC — Healthcare General Contracting</Text>
        <Text style={{ fontSize: 9, color: c.sky, marginTop: 4 }}>Electrical | Plumbing | Construction | Repairs | Remodels | New Build</Text>
        <Text style={{ fontSize: 8, color: '#94A3B8', marginTop: 6 }}>HUB Certified | Licensed | Healthcare Compliant | No Job Too Big or Too Small</Text>
      </View>
      <Ft />
    </Page>
  </Document>
);

export default GeneralContractorBrochurePDF;
